// /ochrana-udajov — Blok 4, Týž. 17. GDPR info pre osobné údaje štatutárov/UBO
// (verejné registre) aj pre účty používateľov. Nie je to právne poradenstvo (docs/00 §5).
export function PrivacyPage() {
  return (
    <main className="page page-narrow">
      <h1 style={{ fontSize: '1.4rem' }}>Ochrana osobných údajov</h1>
      <p style={{ color: 'var(--slate)', fontSize: '0.85rem' }}>Platné od 12. júla 2026</p>

      <div style={{ color: 'var(--ink)', fontSize: '0.92rem', lineHeight: 1.7 }}>
        <h3 style={sectionH}>1. Prevádzkovateľ</h3>
        <p>
          Corpuls (súčasť rodiny produktov Marstein). Kontakt vo veciach ochrany osobných údajov:{' '}
          <a href="mailto:info@marstein.sk">info@marstein.sk</a>.
        </p>

        <h3 style={sectionH}>2. Osobné údaje z verejných registrov</h3>
        <p>
          Zobrazujeme mená, dátumy narodenia (ak sú vo zdroji) a role štatutárov, spoločníkov a
          konečných užívateľov výhod (UBO) firiem — tieto údaje pochádzajú výhradne z verejne
          dostupných registrov (Register právnických osôb, Register partnerov verejného sektora,
          register diskvalifikovaných osôb), kde sú zo zákona zverejnené. Právnym základom
          spracovania je oprávnený záujem (čl. 6 ods. 1 písm. f GDPR) — sprístupnenie verejne
          publikovaných informácií o podnikateľskej činnosti, v rovnakom rozsahu, v akom sú dostupné
          v pôvodnom registri. Rodné číslo nikde nezískavame ani nezobrazujeme.
        </p>

        <h3 style={sectionH}>3. Osobné údaje používateľov účtu</h3>
        <p>
          Pri registrácii ukladáme email a (pri registrácii heslom) zahashovanú podobu hesla — heslo
          v čitateľnej podobe nikdy neukladáme. Pri prihlásení cez Google ukladáme email a Google
          identifikátor účtu. Pri predplatnom ukladáme identifikátor zákazníka v Stripe (platby
          spracúva Stripe, nie my priamo). Watchlist (sledované firmy) je viazaný na tvoj účet.
        </p>

        <h3 style={sectionH}>4. Súbory cookie</h3>
        <p>
          Používame jeden nutný funkčný cookie (<code>session</code>) na udržanie prihlásenia — bez
          neho by appka nevedela rozoznať prihláseného používateľa. Pri prihlásení cez Google
          dočasne aj <code>oauth_state</code> (10 minút, ochrana proti CSRF). Nepoužívame reklamné
          ani analytické sledovacie cookies tretích strán.
        </p>

        <h3 style={sectionH}>5. Doba uchovávania</h3>
        <p>
          Údaje účtu uchovávame, kým máš aktívny účet. Po zrušení účtu údaje vymažeme do 30 dní,
          okrem prípadov, keď nám zákon ukladá dlhšiu dobu uchovávania (napr. účtovné doklady k
          predplatnému).
        </p>

        <h3 style={sectionH}>6. Tvoje práva</h3>
        <p>
          Máš právo na prístup k svojim údajom, opravu, výmaz, obmedzenie spracovania, prenosnosť a
          namietanie — napíš na <a href="mailto:info@marstein.sk">info@marstein.sk</a>. Pri údajoch
          zo zdrojových registrov (štatutári/UBO) odporúčame opravu riešiť priamo v pôvodnom
          registri — my ho len sprístupňujeme, nevytvárame.
        </p>

        <h3 style={sectionH}>7. Zdieľanie údajov</h3>
        <p>
          Údaje nepredávame tretím stranám. Spracovatelia: hosting (vlastný server, Hetzner Cloud,
          Nemecko/Fínsko podľa lokality), platby (Stripe), email (SMTP poskytovateľ podľa aktuálnej
          konfigurácie).
        </p>

        <p style={{ color: 'var(--slate-light)', fontSize: '0.78rem', marginTop: '2rem' }}>
          Tento dokument nie je právne poradenstvo a bude pred plným komerčným spustením
          doplnený/potvrdený právnikom.
        </p>
      </div>
    </main>
  );
}

const sectionH = { fontSize: '1.02rem', marginTop: '1.6rem', color: 'var(--navy-900)' } as const;
